import { faExpand, faMinimize } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
export function RydCollapseControlButton({
    collapsed,
    setCollapsed
}: {
    collapsed: boolean,
    setCollapsed: (collapsed: boolean) => void
}) {
    return (<button onClick={() => setCollapsed(!collapsed)}>
        {collapsed ? <FontAwesomeIcon icon={faExpand} /> : <FontAwesomeIcon icon={faMinimize} />}
    </button>);
}